var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"filter clearfix"},_vm._l((_vm.visibleTabs),function(label,id){return _c('li',[_c('a',{class:{ active: (_vm.current === id) },attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.setCurrent(id)}}},[_vm._v(_vm._s(label))])])}))}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06b9ee4f","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/MaterialFilter.vue
// module id = CCns
// module chunks = 0